/* a component that is used to configure a field in a form. */
import { Button, FormControl, Modal, OverlayTrigger } from "react-bootstrap"
import Select from "react-select"
import fieldMap from "../../DynamicForm/Fields/FieldMap"
import FieldTypes from "../../Types/FieldTypes"
import UserReferenceTypes from "src/store/UserReference/types"
import CustomDropdownConfig from "./CustomDropdownConfig/CustomDropdownConfig"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import paletteEngine from "../../Utils/paletteEngine"
import mobileFriendlyWarning from "../../Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import "./DynamicFormFieldConfig.css"

interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    dropDownReference: Array<{ name: string, values: Array<UserReferenceTypes> }> | null
    addOrRemoveColumn: Function
    template: Array<Array<FieldTypes>> | []
    palette: Array<DynamicFormPaletteTypes>
    hints: boolean
}

function DynamicFormFieldConfig(props: Props) {

    const field = props.field
    const configField = fieldMap.buildConfigField(field, props.palette, props.row, props.col, props.handleChange, props.manageParentState, props.addOrRemoveColumn)
    const configHelper = configField.configHelper
    const fieldType = configHelper.fieldType
    const validators = configHelper.validators
    const formatters = configHelper.formatters
    const dropdown = fieldType === "dropDown"
    const multiSelect = fieldType === "multiSelectDropDown"
    const hideRequired = fieldType === "section" || fieldType === "staticText" || fieldType === "samsaraS3Video"
    const useCustomDropdownConfigItems = props.template[props.row][props.col].CustomDropDown
    const showMobileValidatorWarning = (field.Validator && field.Validator.type)
    const showMobileFormatterWarning = (field.Formatter && field.Formatter.type)
    // console.log("df_DynamicFormFieldConfig template", props)
    return (
        <div className="DynamicFormFieldConfig">
            <Modal
                id="dynamic-form-field-config-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
            >
                <Modal.Header>
                    <div className="DynamicFormFieldConfigModalHeader">
                        <p>{`Configure this ${field.Type} field`}</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="DynamicFormFieldConfigModalBody">
                        <div className="DynamicFormFieldConfigModalBodyFieldPreview" style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
                            {configField.field}
                        </div>
                        <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldOptions">
                            {/*******************************************************Name**********************************************************************/}
                            <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldOptionsItem">
                                <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldOptionsItemHeader">
                                    <p>Display Name</p>
                                </div>
                                <FormControl onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Name" } }])}
                                    //@ts-ignore
                                    onChange={props.handleChange}
                                    value={field.Name || ""}
                                />
                            </div>
                            {/*******************************************************Dropdown**********************************************************************/}
                            {props.dropDownReference && dropdown && !useCustomDropdownConfigItems &&
                                <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldOptionsItem">
                                    <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldOptionsItemReferenceOptions">
                                        <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldOptionsItemHeader">
                                            <p>Options</p>
                                        </div>
                                        <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldFormattersOrValidatorsOrDropdownsInputWrapper">
                                            <Select
                                                //@ts-ignore
                                                value={{ label: field.ReferenceName || "Choose reference data" }}
                                                //@ts-ignore
                                                options={props.dropDownReference.map((item) => ({ value: item.values, label: item.name }))}
                                                onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "CustomValues" } }])}
                                                onChange={(item: any) => {
                                                    props.handleChange({ target: { value: item.value } })
                                                    if (!useCustomDropdownConfigItems) {
                                                        props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "ReferenceName" } }])
                                                    }
                                                    props.handleChange({ target: { value: item.label } })
                                                }}
                                                isDisabled={useCustomDropdownConfigItems}
                                            />
                                            {field.ReferenceName && <span className="material-icons" onClick={() => {
                                                props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "ReferenceName" } }])
                                                props.handleChange({ target: { value: null } })
                                            }}>close</span>}
                                        </div>
                                    </div>
                                </div>}
                            {/*******************************************************Multi Select**********************************************************************/}
                            {props.dropDownReference && multiSelect && !useCustomDropdownConfigItems &&
                                <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldOptionsItem">
                                    <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldOptionsItemReferenceOptions">
                                        <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldOptionsItemHeader">
                                            <p>Dropdown Options</p>
                                        </div>
                                        <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldFormattersOrValidatorsOrDropdownsInputWrapper">
                                            <Select
                                                //@ts-ignore
                                                value={{ label: field.ReferenceName || "Choose reference data" }}
                                                //@ts-ignore
                                                options={props.dropDownReference.map((item) => ({ value: item.values, label: item.name }))}
                                                onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "CustomValues" } }])}
                                                onChange={(item: any) => {
                                                    props.handleChange({ target: { value: item.value } })
                                                    if (!useCustomDropdownConfigItems) {
                                                        props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "ReferenceName" } }])
                                                    }
                                                    props.handleChange({ target: { value: item.label } })
                                                }}
                                                isDisabled={useCustomDropdownConfigItems}
                                            />
                                            {field.ReferenceName && <span className="material-icons" onClick={() => {
                                                props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "ReferenceName" } }])
                                                props.handleChange({ target: { value: null } })
                                            }}>close</span>}
                                        </div>
                                    </div>
                                </div>}
                            {/*******************************************************Custom Options**********************************************************************/}
                            {(multiSelect || dropdown) &&
                                <CustomDropdownConfig
                                    manageGranparentState={props.manageParentState}
                                    target={{ row: props.row, col: props.col }}
                                    template={props.template}
                                    hints={props.hints}
                                />}
                            {/*******************************************************Formatters / Validators********************************************************/}
                            {formatters.length > 0 && <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldFormattersOrValidators">
                                <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldFormattersOrValidatorsHeader">
                                    <p>Formatters</p>
                                    <div className="DynamicFormFieldConfigMobileFormatterOrValidatorWarning">
                                        {showMobileFormatterWarning && <OverlayTrigger placement="top" overlay={mobileFriendlyWarning("Formatters", "Formatters are web-only and not mobile-friendly")}>
                                            <span className="material-icons">priority_high</span>
                                        </OverlayTrigger>}
                                    </div>
                                </div>
                                <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldFormattersOrValidatorsOrDropdownsInputWrapper">
                                    <Select
                                        //@ts-ignore
                                        value={{ label: field.Formatter ? field.Formatter.type : "Choose formatter" }}
                                        options={formatters.map((item) => ({ label: item.type, value: { type: item.type, formatter: item.formatter } }))}
                                        onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Formatter" } }])}
                                        onChange={(item: { value: string, label: string }) => {
                                            //@ts-ignore
                                            props.handleChange({ target: { value: item.value } })
                                        }}
                                    />
                                    {(field.Formatter && field.Formatter.type) && <span className="material-icons" onClick={() => {
                                        props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Formatter" } }])
                                        props.handleChange({ target: { value: null } })
                                    }}>close</span>}
                                </div>
                            </div>}
                            {validators.length > 0 && <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldFormattersOrValidators">
                                <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldFormattersOrValidatorsHeader">
                                    <p>Validators</p>
                                    <div className="DynamicFormFieldConfigMobileFormatterOrValidatorWarning">
                                        {showMobileValidatorWarning && <OverlayTrigger placement="top" overlay={mobileFriendlyWarning("Validators", "Validators are web-only and not mobile-friendly")}>
                                            <span className="material-icons">priority_high</span>
                                        </OverlayTrigger>}
                                    </div>
                                </div>
                                <div className="DynamicFormFieldConfigModalBodyFieldPreviewFieldFormattersOrValidatorsOrDropdownsInputWrapper">
                                    <Select
                                        //@ts-ignore
                                        value={{ label: field.Validator ? field.Validator.type : "Choose validator" }}
                                        options={validators.map((item) => ({ label: item.type, value: { type: item.type, validator: item.validator } }))}
                                        onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Validator" } }])}
                                        onChange={(item: { value: string, label: string }) => {
                                            //@ts-ignore
                                            props.handleChange({ target: { value: item.value } })
                                        }}
                                    />
                                    {(field.Validator && field.Validator.type) && <span className="material-icons" onClick={() => {
                                        props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Validator" } }])
                                        props.handleChange({ target: { value: null } })
                                    }}>close</span>}
                                </div>
                            </div>}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="DynamicFormFieldConfigModalFooter">
                        {/*******************************************************Required**********************************************************************/}
                        <div className="DynamicFormFieldConfigModalFooterLeft">
                            {!hideRequired && <div className="DynamicFormFieldConfigModalFooterIsRequired">
                                <div className="DynamicFormFieldConfigModalFooterIsRequiredHeader" >
                                    <p>Required?</p>
                                </div>
                                <FormControl onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Required" } }])}
                                    //@ts-ignore
                                    value={field.Value || ""}
                                    checked={field.Required}
                                    onChange={() => { props.handleChange({ target: { value: !field.Required } }) }}
                                    type="checkbox"
                                />
                            </div>}
                        </div>
                        <div className="DynamicFormFieldConfigModalFooterRight">
                            <Button onClick={() => props.manageParentState([{ key: "configTarget", value: { row: -1, col: -1 } }])}>Ok</Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DynamicFormFieldConfig